export default "__VITE_PUBLIC_ASSET__a1442ac0__"